/**
 * Q4 2021: Actually, we could use this file directly because we don't need to use an offline version
 * for local development any more --> we can directly connect to the cbook backend on staging!
 */ /**
 * Do not use this file.
 * Instead require utils/SocialAPIUtils.js which in turn requires the desired file.
 * Why?
 *  It is simple to "hotswap" an offline version + an online version.
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import SocialServerActionCreators from "../../actions/SocialServerActionCreators";
import AjaxUtils from "../AjaxUtils";
import Log from "../Log";
import Promise1 from "bluebird";
import JsonSources from "../JsonSources";
import store from "../../store";
import { initEngagementSession, sendAlert, logError, loginSuccess, createActivitySuccess, updateTopicSuccess } from "../../actions";
import pick from "lodash/pick";
import each from "lodash/forEach";
import map from "lodash/map";
import merge from "lodash/merge";
var _endpoint = ""; // = endpoint
var _endpointV2 = ""; // = endpointV2
var _token = ""; // = API
var _sessionToken = ""; // = Session, after successfull auth.
var _createActivity = function(topic, activity) {
    return AjaxUtils.postJSON(_endpointV2 + "/topics/" + topic.id + "/activities", activity, {
        Authorization: _sessionToken
    });
};
var _updateActivity = function(topic, activity) {
    return AjaxUtils.postJSON(_endpointV2 + "/topics/" + topic.id + "/activities/" + activity.id, activity, {
        Authorization: _sessionToken
    });
};
var _deleteActivity = function(topic, activity) {
    return AjaxUtils.deleteJSON(_endpointV2 + "/topics/" + topic.id + "/activities/" + activity.id, null, {
        Authorization: _sessionToken
    });
};
var handleError = function(error) {
    var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var msg = error.message ? error.message : typeof error.errorThrown === "string" ? error.errorThrown : !!scope && error.errorThrown.status ? "social.".concat(scope, ".error.").concat(error.errorThrown.status) : error.errorThrown.msg ? error.errorThrown.msg : error.errorThrown.errors ? Object.keys(error.errorThrown.errors).map(function(k) {
        return error.errorThrown.errors[k].join(", ");
    }).join("; ") : error.errorThrown.status;
    store.dispatch(sendAlert({
        message: msg,
        messageType: "danger"
    }));
    console.error(error);
    store.dispatch(logError({
        error: error,
        key: scope
    }));
};
export default {
    readConfiguration: function readConfiguration() {
        return AjaxUtils.getJSON(JsonSources.configPath);
    },
    setAPIConfig: function setAPIConfig(url, token) {
        _token = token;
        _endpoint = url;
        _endpointV2 = "".concat(url, "/v2");
    },
    getSessionToken: function getSessionToken() {
        return _sessionToken;
    },
    getEndpoint: function getEndpoint() {
        return _endpoint;
    },
    /**
   * S E S S I O N
   */ getTweetConfig: function getTweetConfig() {
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpoint, "/config"), {
                token: _token
            }, {
                Authorization: _sessionToken
            }).then(function(socialConfig) {
                resolve(socialConfig);
            }).catch(function(error) {
                handleError(error);
                reject(error);
                Log.error(error.stack);
            }).done();
        });
    },
    /**
   * @param token {string}
   * @param user  {object} consists of attributes: id, name
   */ createTokenBasedSession: function createTokenBasedSession(user) {
        // A signup works like this:
        //  when success => action.receiveSession
        //  when failed => create a user =>
        //                 => when success then signup again
        //                 => otherwise action.receiveSessionError
        var authenticateUser = function() {
            return AjaxUtils.postJSON("".concat(_endpoint, "/session/token"), {
                id: user === null || user === void 0 ? void 0 : user.id,
                token: _token
            }, {});
        };
        var loadUserOnPromiseFullFilled = function(u) {
            _sessionToken = u.session_token;
            // remove session token from user before passing it to session reducer
            // session token will only be stored locally here and exposed via getSessionToken
            delete u.session_token;
            store.dispatch(initEngagementSession({
                session: u
            }));
            store.dispatch(loginSuccess());
        };
        return authenticateUser().then(loadUserOnPromiseFullFilled, function(err) {
            console.warn("Failed to authenticate user, trying to create a new one instead", err);
            // We failed to login, try to create a user.
            return AjaxUtils.postJSON("".concat(_endpoint, "/users?token=").concat(encodeURIComponent(_token)), {
                name: user === null || user === void 0 ? void 0 : user.name,
                foreign_id: user === null || user === void 0 ? void 0 : user.id
            }, {}, function() {}).then(function() {
                // After create: authenticate & load or report devastating error
                authenticateUser().then(loadUserOnPromiseFullFilled).catch(function() {
                    Log.error("This time we really failed to create a user");
                });
            }).catch(handleError);
        }).catch(function(err) {
            handleError(err);
            Log.error(err);
            if (err && err.stack) {
                Log.error(err.stack);
            }
        });
    },
    /**
   *  D I S C L A I M E R
   */ acceptDisclaimer: function acceptDisclaimer() {
        // TODO: Call the accept API
        return AjaxUtils.postJSON("".concat(_endpoint, "/disclaimers/endorse"), null, {
            Authorization: _sessionToken
        }, function() {}).then(function(data) {
            return !!data.success;
        }).catch(handleError);
    },
    /**
   * S P H E R E S
   */ getAllSpheres: function getAllSpheres() {
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpoint, "/groups"), null, {
                Authorization: _sessionToken
            }).then(function(groups) {
                var newGroups = groups.map(function(s) {
                    s.members = s.members || [];
                    return s;
                });
                resolve(newGroups);
                return newGroups;
            }).catch(function(error) {
                handleError(error);
                Log.error(error.stack);
                reject(error);
            }).done();
        });
    },
    /**
   * This will do two things
   *  - create a sphere without naming it
   *  - add the users to that list
   *  - send the result back in to the application stack
   * @params owner   {object}
   * @params members {array}
   * @return {Promise}
   */ createSphere: function createSphere(sphere) {
        var headerAuth = {
            Authorization: _sessionToken
        };
        var _sphere = pick(sphere, [
            "members",
            "name"
        ]);
        return AjaxUtils.postJSON("".concat(_endpoint, "/groups"), _sphere, headerAuth, function() {}).then(function(sphere) {
            Log.log(sphere);
            return sphere;
        }).catch(function(error) {
            handleError(error);
            Log.error(error);
            throw error;
        });
    },
    updateSphere: function updateSphere(sphere) {
        var headerAuth = {
            Authorization: _sessionToken
        };
        var _sphere = pick(sphere, [
            "members",
            "name"
        ]);
        return AjaxUtils.postJSON(_endpoint + "/groups/" + sphere.id, _sphere, headerAuth, function() {}).then(function(sphere) {
            Log.log(sphere);
            return sphere;
        }).catch(function(error) {
            handleError(error);
            Log.error(error);
        });
    },
    toggleSphereVisibility: function toggleSphereVisibility(sphere) {
        return AjaxUtils.postJSON("".concat(_endpoint, "/groups/").concat(sphere.id, "/toggle_visibility"), sphere, {
            Authorization: _sessionToken
        }, function() {}).then(function(rawSphere) {
            return rawSphere;
        }).catch(function(error) {
            handleError(error);
        });
    },
    /**
   * T O P I C S
   */ /**
   * Search the topics, based on the given search
   * @param {spheres: [Object], nodes: [Object]} options
   */ getAllTopics: function getAllTopics(options) {
        var queryParams = {
            group_ids: map(options.spheres || [], "id").join(","),
            node_ids: map(options.nodes || [], "id").join(",")
        };
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpoint, "/topics"), queryParams, {
                Authorization: _sessionToken
            }).then(function(topics) {
                resolve(topics);
                return topics;
            }).catch(function(error) {
                Log.error(error.stack);
                handleError(error);
                reject(error);
            }).done();
        });
    },
    getTopic: function getTopic(topic) {
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpointV2, "/groups/").concat(topic.group_id, "/topics/").concat(topic.id), null, {
                Authorization: _sessionToken
            }).then(function(topic) {
                resolve(topic);
                return topic;
            }).catch(function(error) {
                Log.error(error.stack);
                handleError(error);
                reject(error);
            });
        });
    },
    /**
   * @param {object} sphere the sphere in which the topic shall be created
   * @param {string} topicTitle describes the title of the topic
   * @param {object} activity consists of attrs: body
   * @return {Promise} for this transaction
   */ createTopic: function createTopic(sphere, topicTitle, activity) {
        var topic = {
            title: topicTitle,
            description: activity.body
        };
        return AjaxUtils.postJSON("".concat(_endpoint, "/groups/").concat(sphere.id, "/topics"), topic, {
            Authorization: _sessionToken
        }, function() {}).then(function(t) {
            return t;
        }, function(err) {
            topic.description = activity || {
                body: ""
            };
            handleError(err);
            console.error(merge(topic, err));
        }).catch(function(err) {
            handleError(err);
            Log.error("Fatal");
            Log.error(err.stack);
        });
    },
    /**
   * @param {object} sphere the sphere in which the topic shall be created
   * @param {string} topicTitle describes the title of the topic
   * @param {object} activity consists of attrs: body
   * @param {object} origTopic is the Topic to be duplicated
   * @return {Promise} for this transaction
   */ duplicateTopic: function duplicateTopic(sphere, topicTitle, activity, origTopic) {
        var topic = {
            title: topicTitle,
            description: activity.body
        };
        return AjaxUtils.postJSON("".concat(_endpoint, "/groups/").concat(origTopic.group_id, "/topics/").concat(origTopic.id, "/duplicate?group_id=").concat(sphere.id), topic, {
            Authorization: _sessionToken
        }, function() {}).then(function(t) {
            // TO DO: migrate aways from SocialServerActionCreators
            // SocialServerActionCreators.receiveTopic(t)
            SocialServerActionCreators.receiveActivity(t.description, t);
            return t;
        }, function(err) {
            topic.description = activity || {
                body: ""
            };
            handleError(err);
            console.error(merge(topic, err));
        }).catch(function(err) {
            Log.error("Fatal");
            Log.error(err.stack);
            handleError(err);
        });
    },
    /**
   * Update a Topic on the server
   * and the corresponding description (aka activity)
   * @param {object} topic  the topic itself
   */ updateTopic: function updateTopic(topic, activity) {
        var newTopic;
        topic.errors = {};
        activity.errors = {};
        return new Promise1(function(resolve, reject) {
            AjaxUtils.postJSON("".concat(_endpoint, "/groups/").concat(topic.group_id, "/topics/").concat(topic.id), {
                title: topic.title
            }, {
                Authorization: _sessionToken
            }, function() {}).then(function(t) {
                newTopic = t;
                _updateActivity(newTopic, activity).then(function(newActivity) {
                    newTopic.description = newActivity;
                    // TO DO: migrate aways from SocialServerActionCreators
                    // SocialServerActionCreators.receiveTopic(newTopic);
                    store.dispatch(updateTopicSuccess({
                        activity: newActivity,
                        topicId: topic.id,
                        topic: newTopic
                    }));
                    resolve(newTopic);
                }, function(error) {
                    topic.description = merge(activity, error);
                    reject(topic);
                }).catch(function(err) {
                    Log.error("Fatal");
                    Log.error(err.stack);
                    handleError(err);
                });
            }, function(error) {
                handleError(error);
                reject(merge(topic, error));
            }).catch(function(error) {
                handleError(error);
                reject(merge(topic, error));
            });
        });
    },
    searchTopics: function searchTopics(options) {
        var queryParams = {
            search: options.query,
            group_ids: options.spheres.join(","),
            node_ids: map(options.nodes || [], "id").join(",")
        };
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpoint, "/topics"), queryParams, {
                Authorization: _sessionToken
            }).then(function(result) {
                return resolve(result);
            }).catch(function(err) {
                handleError(err);
                reject(err);
            }).done();
        });
    },
    /**
   * N O T E S
   */ getNotes: function getNotes(group, options) {
        if (!group) {
            return;
        }
        var queryParams = {
            group_ids: group.id,
            node_ids: map(options.nodes || [], "id").join(",")
        };
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpoint, "/topics"), queryParams, {
                Authorization: _sessionToken
            }).then(function(notes) {
                resolve(notes);
            }).catch(function(error) {
                Log.error(error.stack);
                handleError(error);
                reject(error);
            }).done();
        });
    },
    getNote: function getNote(note) {
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpoint, "/groups/").concat(note.group_id, "/topics/").concat(note.id), null, {
                Authorization: _sessionToken
            }).then(function(note) {
                resolve(note);
            }).catch(function(error) {
                Log.error(error.stack);
                handleError(error);
                reject(error);
            });
        });
    },
    getPrintNotes: function getPrintNotes() {
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpoint, "/print/notes"), null, {
                Authorization: _sessionToken
            }).then(function(notes) {
                resolve(notes);
            }).catch(function(error) {
                Log.error(error.stack);
                handleError(error);
                reject(error);
            }).done();
        });
    },
    deleteNote: function deleteNote(note) {
        var nodes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        var _this = this;
        return new Promise1(function(resolve, reject) {
            AjaxUtils.deleteJSON("".concat(_endpoint, "/groups/").concat(note.group_id, "/topics/").concat(note.id), {}, {
                Authorization: _sessionToken
            }).then(function(ret) {
                var sphere = store.getState().groups.noteGroup;
                console.log("my sphere", sphere);
                _this.getNotes(sphere, {
                    nodes: nodes
                });
                resolve(ret);
            }).catch(function(error) {
                Log.error(error.stack);
                handleError(error);
                reject(error);
            });
        });
    },
    /**
   * A C T I V I T I E S
   */ /**
   * @params {object} activity
   * @params {object} topic
   * @return {Promise}
   */ createActivity: function createActivity(activity, topic) {
        return _createActivity(topic, activity).then(function(a) {
            store.dispatch(createActivitySuccess({
                activity: a
            }));
            return a;
        }).catch(function(err) {
            handleError(err);
            Log.error(err.stack);
        });
    },
    /**
   * @params {object} activity
   * @params {object} topic
   * @return {Promise}
   */ updateActivity: function updateActivity(activity, topic) {
        return _updateActivity(topic, activity).then(function(a) {
            return a;
        }).catch(function(err) {
            handleError(err);
            Log.error(err.stack);
        });
    },
    /**
   * @params {object} activity
   * @params {object} topic
   * @return {Promise}
   */ deleteActivity: function deleteActivity(activity, topic) {
        return _deleteActivity(topic, activity).then(function(a) {
            /**
         * _deleteActivity only responds with { status: "ok" }
         * the deleted activity is therefore stripped from it's content fields, and marked as deleted
         */ var _ref = _objectSpreadProps(_objectSpread({}, activity), {
                deleted_at: true
            }), body = _ref.body, assets = _ref.assets, _is_new = _ref._is_new, deletedActivity = _objectWithoutProperties(_ref, [
                "body",
                "assets",
                "_is_new"
            ]);
            return a;
        }).catch(function(err) {
            handleError(err);
            Log.error(err.stack);
        }).done();
    },
    getActivity: function getActivity(activity, topic) {
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpointV2, "/topics/").concat(topic.id, "/activities/").concat(activity.id), null, {
                Authorization: _sessionToken
            }).then(function(a) {
                resolve(a);
                return a;
            }).catch(function(error) {
                Log.error(error.stack);
                handleError(error);
                reject(error);
            });
        });
    },
    deleteAsset: function deleteAsset(activity, id) {
        return new Promise1(function(resolve, reject) {
            AjaxUtils.postJSON("".concat(_endpoint, "/activities/").concat(activity.id, "/assets/").concat(id, "/delete"), null, {
                Authorization: _sessionToken
            }, function() {}).then(function(a) {
                Log.log(a);
                resolve(a);
            }).catch(function(error) {
                Log.error(error.stack);
                handleError(error);
                reject(error);
            });
        });
    },
    /**
   * U S E R S
   */ /**
   * Search Users
   * @param {string} searchTerm
   * @param {func} successFn  a Callback when everything works fine
   * @param {func} errorFn    a Callback when something went wrong
   */ searchUsers: function searchUsers(searchTerm, successFn, errorFn) {
        if (searchTerm && searchTerm.length >= 2) {
            AjaxUtils.getJSON("".concat(_endpoint, "/users"), {
                term: searchTerm
            }, {
                Authorization: _sessionToken
            }, function(users, status, xhr) {
                if (xhr.status === 200) {
                    successFn(users);
                } else {
                    Log.error("TODO> Error on fetching the users");
                }
            });
        } else {
            errorFn("Zumindest 2 Zeichen eingeben ...");
        }
    },
    getAllUsers: function getAllUsers() {
        var term = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpoint, "/users"), {
                term: term
            }, {
                Authorization: "" + _sessionToken
            }).then(function(users) {
                resolve(users);
            }).catch(function(error) {
                Log.error(error.stack);
                handleError(error);
                reject(error);
            });
        });
    },
    /**
   * V E R S I O N
   */ getTweetVersion: function getTweetVersion() {
        return new Promise1(function(resolve, reject) {
            AjaxUtils.getJSON("".concat(_endpoint, "/version"), null, {}).then(function(data) {
                resolve(data);
            }).catch(function(error) {
                handleError(error);
                reject(error);
                Log.error(error.stack);
            }).done();
        });
    },
    /**
   * R A T I N G
   */ getRating: function getRating(target, dimension) {
        return AjaxUtils.getJSON("".concat(_endpoint, "/ratings/").concat(target, "/").concat(dimension), {}, {
            Authorization: _sessionToken
        });
    },
    setRating: function setRating(target, dimension, stars) {
        return AjaxUtils.postJSON("".concat(_endpoint, "/ratings/").concat(target, "/").concat(dimension), {
            stars: stars
        }, {
            Authorization: _sessionToken
        }, function() {});
    },
    /**
   * E X T E N S I O N S (Plugin Store)
   */ savePluginData: function(plugin_id, node_id, data) {
        var params = {
            plugin_id: plugin_id,
            data: data,
            node_id: node_id
        };
        if (node_id) {
            params.node_id = node_id;
        }
        return new Promise1(function(resolve, reject) {
            AjaxUtils.postJSON("".concat(_endpoint, "/plugin_store?plugin_id=").concat(plugin_id, "&node_id=").concat(node_id), params, {
                Authorization: _sessionToken
            }, function() {}).then(function(_d) {
                if (_d.data && typeof _d.data === "string") {
                    _d.data = JSON.parse(_d.data);
                }
                resolve(_d);
            }).catch(function(err) {
                handleError(err, "plugin store");
                Log.error(err.stack);
                reject(err);
            });
        });
    },
    getPluginData: function getPluginData(plugin_id, node_id) {
        var params = {
            plugin_id: plugin_id
        };
        if (node_id) {
            params.node_id = node_id;
        }
        return new Promise1(function(resolve, reject) {
            var poolData = function() {
                if (_sessionToken) {
                    AjaxUtils.getJSON("".concat(_endpoint, "/plugin_store"), params, {
                        Authorization: _sessionToken
                    }).then(function(_d) {
                        if (_d.data && typeof _d.data === "string") {
                            _d.data = JSON.parse(_d.data);
                        } else {
                            _d.data = {};
                        }
                        resolve(_d);
                    }).catch(function(err) {
                        handleError(err, "plugin_store");
                        reject(err);
                    }).done();
                } else {
                    setTimeout(poolData, 200);
                }
            };
            poolData();
        });
    },
    getCommunityPluginData: function getCommunityPluginData(plugin_id, node_id) {
        var params = {
            plugin_id: plugin_id,
            node_id: node_id
        };
        return new Promise1(function(resolve, reject) {
            if (!node_id) {
                reject({
                    errorThrown: {
                        error: "No Node Id given which is required"
                    }
                });
            } else {
                var poolData = function() {
                    if (_sessionToken) {
                        AjaxUtils.getJSON("".concat(_endpoint, "/plugin_store/all"), params, {
                            Authorization: _sessionToken
                        }).then(function(_d) {
                            each(_d, function(u) {
                                if (u.data && typeof u.data === "string") {
                                    u.data = JSON.parse(u.data);
                                }
                            });
                            resolve(_d);
                        }).catch(function(err) {
                            Log.error(err.stack);
                            handleError(err);
                            reject(err);
                        }).done();
                    } else {
                        setTimeout(poolData, 200);
                    }
                };
                poolData();
            }
        });
    },
    uploadAsset: function uploadAsset(activity, file, onProgress) {
        var url = "".concat(_endpoint, "/activities/").concat(activity.id, "/assets.html");
        return AjaxUtils.upload(url, [
            {
                file: file
            }
        ], {
            Authorization: _sessionToken
        }, onProgress);
    },
    getUserProfile: function getUserProfile() {
        return new Promise1(function(resolve, reject) {
            var poolData = function() {
                if (_sessionToken) {
                    AjaxUtils.getJSON("".concat(_endpoint, "/users/profile"), {}, {
                        Authorization: _sessionToken
                    }).then(resolve).catch(function(err) {
                        handleError(err, "User profile");
                        reject(err);
                    }).done();
                } else {
                    setTimeout(poolData, 200);
                }
            };
            poolData();
        });
    },
    setUserProfile: function setUserProfile(params) {
        return new Promise1(function(resolve, reject) {
            AjaxUtils.postJSON("".concat(_endpoint, "/users/profile"), params, {
                Authorization: _sessionToken
            }, function() {}).then(resolve, reject);
        });
    }
};
export var getAjaxConfig = function() {
    return {
        headers: {
            Authorization: _sessionToken
        },
        endpoint: _endpoint
    };
};
var buildMeta = function(nestedMessages) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", first = arguments.length > 2 ? arguments[2] : void 0;
    return Object.keys(nestedMessages).reduce(function(messages, key) {
        var value = nestedMessages[key];
        var prefixedKey = prefix !== "" || prefix !== undefined ? "".concat(prefix).concat(first ? "_" : ".").concat(key) : key;
        if (typeof value !== "object") {
            messages[prefixedKey] = value;
        } else {
            Object.assign(messages, buildMeta(value, prefixedKey));
        }
        return messages;
    }, {});
};
export function getPluginAssets(plugin_id, node_id) {
    var all = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return new Promise1(function(resolve, reject) {
        if (!plugin_id || !node_id) {
            reject(new Error("Extension ID or Node ID missing"));
            return;
        }
        AjaxUtils.getJSON("".concat(_endpoint, "/plugin_asset").concat(all ? "/all" : ""), {
            plugin_id: plugin_id,
            node_id: node_id
        }, {
            Authorization: _sessionToken
        }).then(resolve, reject);
    });
}
export function createPluginAsset(plugin_id, node_id, assets, onProgress) {
    return AjaxUtils.upload("".concat(_endpoint, "/plugin_asset"), assets.map(function(a, i) {
        return _objectSpread(_defineProperty({}, "".concat(i, "_file"), a.file), buildMeta(a.meta, i, true));
    }).concat([
        {
            plugin_id: plugin_id,
            node_id: node_id
        }
    ]), {
        Authorization: _sessionToken
    }, onProgress);
}
export function updatePluginAsset(plugin_id, node_id, assets, onProgress) {
    return AjaxUtils.upload("".concat(_endpoint, "/plugin_asset/patch"), assets.map(function(a) {
        var obj = {};
        if (a.id && a.file) {
            obj["".concat(a.id, "_file")] = a.file;
        }
        if (a.id && a.meta) {
            obj = _objectSpread({}, obj, buildMeta(a.meta, a.id, true));
        }
        return obj;
    }).concat([
        {
            plugin_id: plugin_id,
            node_id: node_id
        }
    ]), {
        Authorization: _sessionToken
    }, onProgress);
}
export function deletePluginAsset(plugin_id, node_id) {
    var ids = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return new Promise1(function(resolve, reject) {
        AjaxUtils.postJSON("".concat(_endpoint, "/plugin_asset/delete"), {
            ids: ids,
            plugin_id: plugin_id,
            node_id: node_id
        }, {
            Authorization: _sessionToken
        }).then(function(result) {
            return resolve(result);
        }).catch(function(err) {
            return reject(err);
        });
    });
}
export function getPrintNotes() {
    return _getPrintNotes.apply(this, arguments);
}
function _getPrintNotes() {
    _getPrintNotes = _asyncToGenerator(function() {
        return __generator(this, function(_state) {
            return [
                2,
                AjaxUtils.getJSON("".concat(_endpoint, "/print/notes"), null, {
                    Authorization: _sessionToken
                }).then(function(notes) {
                    return notes;
                }).catch(function(err) {
                    Log.error(err.stack);
                    handleError(err);
                })
            ];
        });
    });
    return _getPrintNotes.apply(this, arguments);
}
